export default "__VITE_ASSET__CKchJYgG__"